<button
    tabindex="-1"
    class="flex"
    type="button"
    title="Click to open"
    (click)="openTooltipPopup()"
>
    <img
        src="assets/svg/flat-info-icon.svg"
        alt="question mark"
        class="tooltip h-[17px]"
    />
</button>
